import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c62d83bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings-users-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Templates"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0 sub-title" }, [
    /*#__PURE__*/_createElementVNode("small", null, "Configure your settings here")
  ])
], -1))
const _hoisted_3 = { class: "card mb-10 pt-10 px-5" }
const _hoisted_4 = { class: "card-header d-flex flex-column" }
const _hoisted_5 = { class: "mb-10" }
const _hoisted_6 = { class: "nav nav-tabs nav-line-tabs" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = ["href", "onClick"]
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = ["href", "onClick"]
const _hoisted_11 = { class: "" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Select Template")
], -1))
const _hoisted_13 = {
  class: "card-body d-flex flex-column",
  style: {"min-height":"300px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigator = _resolveComponent("Navigator")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MailingListsSelect = _resolveComponent("MailingListsSelect")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navigator, {
      to: "/settings",
      text: "Back to settings"
    }),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/settings/templates/email",
              custom: ""
            }, {
              default: _withCtx(({ href, navigate }) => [
                _createElementVNode("li", _hoisted_7, [
                  _createElementVNode("a", {
                    href: href,
                    onClick: navigate,
                    class: _normalizeClass(["nav-link", { active: _ctx.isActive('email') }])
                  }, " Email Templates ", 10, _hoisted_8)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/settings/templates/sms",
              custom: ""
            }, {
              default: _withCtx(({ href, navigate }) => [
                _createElementVNode("li", _hoisted_9, [
                  _createElementVNode("a", {
                    href: href,
                    onClick: navigate,
                    class: _normalizeClass(["nav-link", { active: _ctx.isActive('sms') }])
                  }, " SMS Templates ", 10, _hoisted_10)
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_MailingListsSelect, {
            name: "reminderTo",
            value: _ctx.mailTo,
            onChange: _ctx.handleMailListChange
          }, null, 8, ["value", "onChange"])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_ctx.mailTo)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (!_ctx.loading)
                ? (_openBlock(), _createBlock(_component_router_view, {
                    key: _ctx.$route.path
                  }))
                : (_openBlock(), _createBlock(_component_el_skeleton, {
                    key: 1,
                    rows: 6
                  }))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}